export default __webpack_public_path__ + "static/media/forget.d5103520.svg";